<template>
  <div id="v-admin-panel-upload">
    <div class="v-admin-uploading">
      <form enctype="multipart/form-data">
        <input type="file" accept="image/*" multiple @change="uploadFiles($event)" :disabled="currentStatus !== 0 && currentStatus !== 2"/>
        <span>Upload pictures to your Prism library.</span>
      </form>
    </div>
    <div class="v-tip-friendly" v-if="currentStatus === 0" style="margin-top: 40px;">
      <img class="tip-icon" src="../../../assets/Prisima-Happy.png" />
      <div class="tip-content">
        <b>Uploading multiple images?</b>
        <span>
          No problem! You can select multiple images to upload at once.
        </span>
      </div>
    </div>
    <div v-if="errors.length" class="v-admin-image-errors">
      <ul>
        <li v-for="error of errors" :key="error"><b>{{error.name}}</b>: {{error.message}}</li>
      </ul>
    </div>
    <div class="v-admin-image-part" v-for="(image, index) of rawImages" :key="index">
      <b>{{image.name}}</b> <span style="color: #aaa">#{{index + 1}}</span>
      <div class="v-admin-image-status" v-if="imageStatus[index] === 0">PREPARING</div>
      <div class="v-admin-image-status uploading" v-if="imageStatus[index] === 1">UPLOADING</div>
      <div class="v-admin-image-status success" v-if="imageStatus[index] === 2">SUCCESS</div>
      <div class="v-admin-image-status error" v-if="imageStatus[index] === 3">UPLOAD FAILED</div>
      <div class="v-admin-image-status" v-if="imageStatus[index] === 4">PAUSED</div>
      <div class="v-admin-image-status" v-if="imageStatus[index] === 5">PROCESSING</div>
      <span>{{Math.round(imageProgress[index])}}%</span>
      <i class="material-icons icon-button" @click="togglePauseTask(index)" v-if="imageStatus[index] === 1">pause</i>
      <i class="material-icons icon-button" @click="togglePauseTask(index)" v-if="imageStatus[index] === 4">play_arrow</i>
    </div>
  </div>
</template>
<script>
let uploadCodes = {
  STATUS_INITIAL: 0,
  STATUS_UPLOADING: 1,
  STATUS_SUCCESS: 2,
  STATUS_FAILURE: 3,
  STATUS_PAUSED: 4,
  STATUS_PROCESSING: 5
}

const MD5 = require('crypto-js/md5')

export default {
  props: ['collective'],
  data: function () {
    return {
      rawImages: [],        // Raw images with information for the status
      images: [],           // Promises of uploads
      imageStatus: [],
      imageProgress: [],
      imageTasks: [],
      currentStatus: uploadCodes.STATUS_INITIAL,
      errors: [],
      imageIndex: 0
    }
  },
  methods: {
    // TODO: Move to main Vuex store
    uploadFiles: function (e) {
      this.currentStatus = uploadCodes.STATUS_UPLOADING
      let imageFiles = e.target.files

      let firebaseStore = this.$firebase.storage()

      for (let index = this.imageIndex; index < (imageFiles.length + this.imageIndex); index++) {
        let imageIndex = this.imageIndex
        let image = imageFiles[index - imageIndex]

        this.imageStatus.push(uploadCodes.STATUS_INITIAL)
        this.rawImages.push(image)
        this.imageProgress.push(0)

        this.images.push(new Promise((resolve, reject) => {
          let imageName = image.name.split(' ').join('_').split('.').slice(0, -1).join('.') + '.' + MD5(image.name + image.lastModified) + '.' + MD5(image.lastModified + ':' + (new Date().getTime())) + '.' + image.name.split('.')[image.name.split('.').length - 1]
          let imageRef = firebaseStore.ref().child(`collectives/@${this.collective.handle}/${imageName}`)

          this.imageStatus[index] = uploadCodes.STATUS_UPLOADING
          let task = imageRef.put(image)
          this.imageTasks.push(task)

          task.on('state_changed', (snapshot) => {
            // Update the upload speed
            this.$set(this.imageProgress, index, (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          }, (err) => {
            // Reject when there is an error
            this.$set(this.imageStatus, index, uploadCodes.STATUS_FAILURE)
            reject(err)
          }, (snapshot) => {
            // Successful!
            this.$set(this.imageStatus, index, uploadCodes.STATUS_PROCESSING)

            return this.setImageMetadata(imageFiles[index - imageIndex], imageName).then(() => {
              this.$set(this.imageStatus, index, uploadCodes.STATUS_SUCCESS)
              resolve({ ...image, finishedUploading: true })
              return { ...image, finishedUploading: true }
            })
          })
        }).catch((err) => {
          this.errors.push(err)
        }))
      }

      Promise.all(this.images.slice(this.imageIndex, this.images.length)).then(results => {
        this.$store.dispatch('fetchCollective', this.collective.handle)
        if (results.filter(value => !value.finishedUploading).length === 0) {
          this.currentStatus = uploadCodes.STATUS_SUCCESS
        } else {
          this.currentStatus = uploadCodes.STATUS_FAILURE
        }
      })

      this.imageIndex += imageFiles.length
    },
    reset: function () {
      this.currentStatus = uploadCodes.STATUS_INITIAL
      this.images = []
    },
    setImageMetadata: function (image, imageName) {
      let tag = '$all'
      let imageUpdate = {
        timestamp: (new Date()).getTime()
      }
      let imageStuff = {
        name: image.name.split('.').slice(0, -1).join('.'),
        path: imageName,
        fullpath: `collectives/@${this.collective.handle}/${imageName}`,
        timestamp: (new Date()).getTime()
      }
      imageUpdate['images.' + tag + '@' + MD5(imageName).toString()] = true

      return Promise.all([
        this.$firestore.collection('images').doc('@' + this.collective.handle)
          .collection(tag).doc(MD5(imageName).toString()).set(imageStuff),
        this.$firestore.collection('collectives').doc('@' + this.collective.handle).update(imageUpdate)
      ])
    },
    togglePauseTask: function (index) {
      if (this.imageStatus[index] === uploadCodes.STATUS_UPLOADING) {
        this.$set(this.imageStatus, index, uploadCodes.STATUS_PAUSED)
        this.imageTasks[index].pause()
      } else if (this.imageStatus[index] === uploadCodes.STATUS_PAUSED) {
        this.$set(this.imageStatus, index, uploadCodes.STATUS_UPLOADING)
        this.imageTasks[index].resume()
      } else {
        throw new Error('Attempted to pause an upload in an invalid fashion!')
      }
    }
  },
  mounted: function () {
    // this.reset()
  }
}
</script>
<style lang="scss">
@keyframes pulsatingblue {
  0% {
    background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) #3498db;
  }
  50% {
    background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) darken(#3498db, 16%);
  }
  100% {
    background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) #3498db;
  }
}

.v-admin-uploading {
  margin: 40px;
  margin-bottom: 20px;
  padding: 10px 20px;
  background-color: #ddd;
  font-size: 14px;
  border-radius: 4px;
}
.v-admin-image-part {
  margin: 10px 40px;
  padding: 10px 20px;
  background-color: #ededed;
  font-size: 14px;
  border-radius: 4px;
}

.v-admin-image-status {
  background-color: #333;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  display: inline-block;
  padding: 4px 8px;
  margin: 0 10px;
  border-radius: 4px;
  cursor: default;

  &.uploading {
    background-color: #2980b9;
    animation: pulsatingblue 1000ms ease-in-out infinite;
  }

  &.success {
    background: linear-gradient(to right, #2ecc71, darken(#2ecc71, 8%))
  }

  &.error {
    background: linear-gradient(to right, #c0392b, darken(#c0392b, 8%))
  }
}

.v-admin-image-errors {
  background: linear-gradient(to right, lighten(#c0a92b, 20%), #c0a92b);
  margin: 10px 20px;
  font-size: 14px;
  padding: 15px;

  ul {
    list-style-type: none;
    margin: 0;
      padding: 0;
    li {
      margin: 2px 0;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/General/AdminUpload.vue